import {Component, OnInit} from '@angular/core';
import {FormBaseComponent, TaskDataService, ValidatorService} from '@utils-lib';
import {Betriebstaette, BetriebstaettenAngaben, LohnsteuerAngaben} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {TranslateService} from '@ngx-translate/core';

const MAX_LENGTH = 120;

@Component({
    selector: 'common-ui-lohnsteuer-betriebsstaette',
    templateUrl: './lohnsteuer-betriebsstaette.component.html'
})
export class LohnsteuerBetriebsstaetteComponent extends FormBaseComponent<LohnsteuerAngaben> implements OnInit {

    public betriebstaetten: Array<Betriebstaette> = [];

    constructor(private readonly formBuilder: FormBuilder,
                private readonly validatorService: ValidatorService,
                protected readonly messageService: DatevMessageService,
                protected readonly translateService: TranslateService,
                private readonly taskDataService: TaskDataService) {
        super(messageService);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        const betriebstaettenAngaben: BetriebstaettenAngaben = this.taskDataService.getNutzdaten('betriebstaettenAngaben');

        if (betriebstaettenAngaben?.betriebstaetten?.length > 0) {
            this.betriebstaetten = betriebstaettenAngaben.betriebstaetten.filter(val => val.inlandsadresse);
        }
    }

    public onBetriebstaettePicked(betriebstaette: Betriebstaette): void {
        this.form.get('betriebstaetteBezeichnung').setValue(betriebstaette.bezeichnung);
        this.data.betriebstaetteInlandsadresse = betriebstaette.inlandsadresse;
    }

    protected createForm(): void {
        this.form = this.formBuilder.group({
            betriebstaetteBezeichnung: [
                this.data.betriebstaetteBezeichnung,
                [
                    this.validatorService.maxLength(MAX_LENGTH)
                ]
            ]
        });
    }
}
